class TrFaqAccordion extends HTMLElement {
  #controller;
  #animations = new Map();

  connectedCallback() {
    this.#controller = new AbortController();
    this.addEventListener('click', this.#toggle, { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
    for (const [item, state] of this.#animations) {
      state.animation.cancel();
      item.open = state.opening;
      item.style.overflow = '';
      delete item.dataset.expanded;
    }
    this.#animations.clear();
  }

  #toggle = (event) => {
    const summary = event.target.closest('.tr-faq-accordion__question');
    if (!summary || !this.contains(summary)) return;

    event.preventDefault();
    const item = summary.parentElement;
    const previous = this.#animations.get(item);
    const opening = previous ? !previous.opening : !item.open;
    const startHeight = item.getBoundingClientRect().height;

    previous?.animation.cancel();
    this.#animations.delete(item);
    item.dataset.expanded = String(opening);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {
      item.open = opening;
      item.style.overflow = '';
      return;
    }

    // Keep the native disclosure open until the closing animation finishes.
    item.open = true;
    item.style.overflow = 'hidden';
    const borderHeight = item.offsetHeight - item.clientHeight;
    const endHeight = opening
      ? summary.offsetHeight + item.querySelector('.tr-faq-accordion__answer').offsetHeight + borderHeight
      : summary.offsetHeight + borderHeight;
    const animation = item.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: 260, easing: 'ease' }
    );

    this.#animations.set(item, { animation, opening });
    animation.onfinish = () => {
      item.open = opening;
      item.style.overflow = '';
      this.#animations.delete(item);
    };
  };
}

if (!customElements.get('tr-faq-accordion')) {
  customElements.define('tr-faq-accordion', TrFaqAccordion);
}
